export const CHECK_IF_DIRECT = 'CHECK_IF_DIRECT';
export const GET_LATEST_RECORD = 'GET_LATEST_RECORD';
export const GET_POSSIBLE_RECIPIENTS = 'GET_POSSIBLE_RECIPIENTS';
export const RECORD_HEADERS = 'RECORD_HEADERS';
export const RECORD_SEARCH = 'RECORD_SEARCH';
export const SAVE_USER_PREFERENCES = 'SAVE_USER_PREFERENCES';
export const TRANSMIT_RECORD = 'TRANSMIT_RECORD';
export const VIEW_CARE_RECORD = 'VIEW_CARE_RECORD';



// WEBPACK FOOTER //
// ./src/actions/health/types.js